import { jsx } from "react/jsx-runtime";
import React, { useMemo } from "react";
import { useHotkeys } from "@blueprintjs/core";
import { startCase } from "lodash-es";
export function comboToLabel(def, useSymbols = true) {
  const combo = typeof def === "string" ? def : def.combo;
  if (useSymbols) {
    let parts = combo.replace("++", "+plus").split("+");
    parts = parts.map((p) => symbols[p] || startCase(p) || p);
    return parts.join("");
  } else {
    return combo.split("+").map((p) => startCase(p) || p).join(" + ").replace("Meta", isMac ? "Cmd" : "Ctrl").replace("Mod", isMac ? "Cmd" : "Ctrl").replace("Alt", isMac ? "Option" : "Alt");
  }
}
export const hotkeysById = (hotkeys, mode = "raw") => (id) => {
  const def = getHotkeyProps(hotkeys[id]);
  return def && (mode === "raw" ? def.combo : comboToLabel(def.combo, mode === "symbols"));
};
export const getHotkeyProps = (def, id) => {
  let out;
  if (typeof def === "string") {
    out = { combo: def };
  } else if (def instanceof Array) {
    out = { combo: def[0], label: def[1], ...def[2] || {} };
  } else {
    out = def;
  }
  out.label = out.label || startCase(id);
  return out;
};
export const withHotkeys = (hotkeys, handlers) => {
  return ({ children } = {}) => {
    const memoedHotkeys = useMemo(
      () => Object.keys(hotkeys).map((id) => {
        const { ...props } = getHotkeyProps(hotkeys[id], id);
        return {
          key: id,
          global: props.global !== false,
          onKeyDown: function(e) {
            return handlers[id](e);
          },
          ...props
        };
      }),
      []
    );
    const { handleKeyDown, handleKeyUp } = useHotkeys(memoedHotkeys);
    const newProps = {
      tabIndex: 0,
      onKeyDown: handleKeyDown,
      onKeyUp: handleKeyUp
    };
    return children ? (
      //tnr: if children are passed, we'll clone them with the new props
      React.cloneElement(children, newProps)
    ) : (
      //if not, then we'll return a div that can be used
      /* @__PURE__ */ jsx("div", { className: "hotkeyHandler", ...newProps })
    );
  };
};
const isMac = navigator.userAgent.includes("Mac OS X");
const symbols = {
  cmd: "\u2318",
  meta: "\u2318",
  ctrl: "\u2303",
  alt: "\u2325",
  shift: "\u21E7",
  esc: "\u241B",
  //'⎋',
  enter: "\u23CE",
  backspace: "\u232B",
  plus: "+",
  tab: "\u21E5",
  space: "\u2423",
  capslock: "\u21EA",
  pageup: "\u21DE",
  pagedown: "\u21DF",
  home: "\u2196",
  end: "\u2198",
  left: "\u2190",
  right: "\u2192",
  up: "\u2191",
  down: "\u2193"
};
symbols.mod = symbols[isMac ? "meta" : "ctrl"];
